import React from 'react'
import { useIntl } from 'react-intl'

import differenceInMinutes from 'date-fns/differenceInMinutes'

import { clientIntakesLCx } from '@lyrahealth-inc/shared-app-logic/src/features/assignments/constants'
import { getFriendlyDate } from '@lyrahealth-inc/shared-app-logic/src/features/common/utils/dateUtils'
import { ClientIntakeCancellationPolicyText } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/clientIntakeCancellationPolicyText/ClientIntakeCancellationPolicyText'
import { FormContentHeader } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/formContentHeader/FormContentHeader'
import { FormBody } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/formBody/FormBody'

import { useIntakeForm } from './useIntakeForm'

export const useIntakeModalContent = () => {
  const intl = useIntl()
  const intakeForm = useIntakeForm()
  const intakeResponse = intakeForm?.assignment_responses?.[0]
  const isLCxClientIntake = clientIntakesLCx.includes(intakeForm?.content?.name ?? '')

  const content_meta_data = intakeForm?.content_meta_data
  const response = intakeResponse?.response
  const date = intakeResponse?.submit_date
  const friendlyDate =
    differenceInMinutes(new Date(), new Date(date!)) < 1
      ? 'just now'
      : getFriendlyDate({ date: date!, intl, addPreposition: false, displayTime: false })
  const dateDisplay = `Submitted ${friendlyDate}`
  const group = intakeForm?.content?.group
  const title = intakeForm?.content?.title

  const getClientIntakeCancellationPolicyText = () => {
    if (response?.cancellationConsentText) {
      return (
        <ClientIntakeCancellationPolicyText
          policyText={response?.cancellationConsentText}
          navigateToCancellationPolicyFAQ={() => {}}
        />
      )
    } else {
      return null
    }
  }

  return (
    <>
      <FormContentHeader title={title} group={group} dateDisplay={dateDisplay} />
      <FormBody
        schema={content_meta_data?.schema}
        initialValues={response}
        uiSchema={content_meta_data?.uiSchema}
        instructions={intakeForm?.instructions}
        name={intakeForm?.content?.name}
        saveForm={() => {}}
        readOnly
        intl={intl}
        formButton={undefined}
        withPageBreaks={false}
        useCustomizedActivityIntroduction={intakeForm?.content_meta_data?.useCustomizedActivityIntroduction}
        hasNewLookAndFeel
        formContext={{
          externalValues: {
            shouldShowCancellationPolicyCheckbox: isLCxClientIntake && Boolean(response?.cancellationConsentText),
          },
          customCheckboxTitle: getClientIntakeCancellationPolicyText(),
        }}
      />
    </>
  )
}
